import { useSelector } from "react-redux";
import NoHistoryView from "../NoHistoryView";
import { formatDate } from "../../../../../functions/dateTime/formatDate";

const StateHistoryView = () => {
  const data = useSelector((state) => state.data.data);
  return (
    <>
      {data.state_history.length !== 0 ? (
        <div className="pt-2 max-h-[calc(100%-100px)] overflow-auto hides-scrollbar font-medium">
          {data.state_history.map((item) => {
            return (
              <div className="cy-history-state-li" key={item.id}>
                <p className={`${item.isFilled ? "text-green" : "text-dg2"} w-full`}>
                  {item.isFilled ? "Filled" : "Empty"}
                </p>
                <p className="text-gray-500 w-full">
                  <span className="text-dark-blue font-medium">At: </span>
                  {formatDate(item.createdAt)}
                </p>
                <p className="text-gray-500 w-full text-right">
                  <span className="text-dark-blue font-medium">By: </span>
                  {item.createdBy.fullName}
                </p>
              </div>
            );
          })}
        </div>
      ) : (
        <NoHistoryView msg="No State History Available..!" />
      )}
    </>
  );
};

export default StateHistoryView;
